'use strict';

/**
 * @author Maxim Seredkin
 */

import angular from 'angular';

export default ['$scope', '$uibModalInstance', 'tax', 'taxFilters', 'def',
                function($scope, $modalInstance, tax, taxFilters, def) {
                    $scope.ok = ok;
                    $scope.cancel = cancel;
                    $scope.isSelect = isSelect;

                    init();

                    // region Function

                    function init() {
                        // инициализация модели
                        $scope.tax = angular.copy(tax);
                        $scope.filters = angular.copy(taxFilters);
                        $scope.def = angular.copy(def);
                    }

                    function ok(tax) {
                        $modalInstance.close(tax);
                    }

                    function cancel() {
                        $modalInstance.dismiss();
                    }

                    function isSelect() {
                        return $scope.tax != null && $scope.tax.id != null;
                    }

                    // endregion
                }];
